<template>
	<div class="body">
		<Header></Header>
		<div class="block">
			<div class="banner_case"></div>
			<div class="menu_block">
				<div class="content fsb">
					<dl class="menu_slt">
						<dd :class="type == '1'?'select':''" @click="changeTab('1')">风机类</dd>
						<dd :class="type == '2'?'select':''" @click="changeTab('2')">泵类</dd>
						<dd :class="type == '3'?'select':''" @click="changeTab('3')">搅拌类</dd>
						<dd :class="type == '4'?'select':''" @click="changeTab('4')">磨机类</dd>
					</dl>
					<div class="location">
						当前位置：
						<a href="/">首页</a>
						<i class="icon el-icon-arrow-right"></i>
						<a href="">应用案例</a>
					</div>
				</div>
			</div>

			<!-- 风机类 -->
			<div class="content" v-if="type == '1'">
				<div class="title_01 mt70">风机类</div>
				<div class="case_block">
					<div class="case_top">22~160kW，风机类用用综合节电率 <strong>15%~70%</strong></div>
					<div class="case_img">
						<div class="info">
							<div class="title">中石化油田</div>
							<strong>原设备经过改造本体激励系统后：</strong>
							<p>运行电流降低73.82%，有功功率降低36.15%，有功电量降低40.06%，无功损耗降低98.64%，综合节电率约为47.73%。</p>
						</div>
						<img src="../images/case/case1_1.png" alt="">
					</div>
					<div class="case_text">
						<img src="../images/case/case1_2.png" alt="">
					</div>
				</div>
			</div>
			<!-- 泵类 -->
			<div class="content" v-if="type == '2'">
				<div class="title_01 mt70">泵类</div>
				<div class="case_block">
					<div class="case_top">11~160kW，泵类应用综合节电 <strong>9%~50%</strong></div>
					<div class="case_img">
						<div class="info">
							<div class="title">华联矿业</div>
							<strong>原设备经过改造本体激励系统后：</strong>
							<p>有功功率降低26.59%，视在功率降低33.06%，无功功率降低68.03%，综合节电率约为28.61%。</p>
						</div>
						<img src="../images/case/case2_1.png" alt="">
					</div>
					<div class="case_text">
						<img src="../images/case/case2_2.png" alt="">
					</div>
				</div>
			</div>
			<!-- 搅拌类 -->
			<div class="content" v-if="type == '3'">
				<div class="title_01 mt70">搅拌类</div>
				<div class="case_block">
					<div class="case_top">30~160kW，搅拌类应用综合节电 <strong>25%~60%</strong></div>
					<div class="case_img">
						<div class="info">
							<div class="title">华联矿业</div>
							<strong>原设备经过改造本体激励系统后：</strong>
							<p>有功功率降低26.59%，视在功率降低33.06%，无功功率降低68.03%，综合节电率约为28.61%。</p>
						</div>
						<img src="../images/case/case2_1.png" alt="">
					</div>
					<div class="case_text">
						<img src="../images/case/case2_2.png" alt="">
					</div>
				</div>
			</div>
			<!-- 磨机类 -->
			<div class="content" v-if="type == '4'">
				<div class="title_01 mt70">磨机类</div>
				<div class="case_block">
					<div class="case_top">11~160kW，泵类应用综合节电 <strong>9%~50%</strong></div>
					<div class="case_img">
						<div class="info">
							<div class="title">华联矿业</div>
							<strong>原设备经过改造本体激励系统后：</strong>
							<p>有功功率降低26.59%，视在功率降低33.06%，无功功率降低68.03%，综合节电率约为28.61%。</p>
						</div>
						<img src="../images/case/case2_1.png" alt="">
					</div>
					<div class="case_text">
						<img src="../images/case/case2_2.png" alt="">
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Header from '../components/hearder.vue'
import Footer from '../components/footer.vue'
export default {
	data() {
		return {
			type: '1'
		}
	},
	components: {
		Header,
		Footer
	},
	mounted () {
		this.type = this.$route.query.type ? this.$route.query.type : '1'
	},
	methods: {
		// 切换案例
		changeTab(name) {
			this.type = name
		}
	},
}
</script>

<style lang="less" scoped>
.case_block{
	width: 100%;
	margin-top: 40px;

	.case_top{
		color: #000;
		font-size: 24px;
		width: 100%;
		height: 96px;
		background: #f9f9f9;
		border-radius: 15px;
		display: flex;
		justify-content: center;
		align-items: center;

		strong{
			color: #1265a4;
		}
	}
	.case_img{
		width: 100%;
		margin-top: 50px;
		display: flex;
		justify-content: space-between;

		img{
			width: 795px;
			height: 390px;
			margin-left: 45px;
			flex-shrink: 0;
			object-fit: cover;
		}

		.title{
			color: #1265a4;
			font-size: 30px;
			margin-top: 40px;
			padding-bottom: 20px;
			font-weight: bold;
			position: relative;

			&:after{
				content: '';
				width: 50px;
				height: 4px;
				background: #999;
				position: absolute;
				left: 0;
				bottom: 0;
			}
		}
		strong{
			color: #000;
			font-size: 20px;
			margin-top: 25px;
			display: block;
		}
		p{
			color: #333;
			font-size: 20px;
			line-height: 40px;
			margin-top: 25px;
			display: block;
		}
	}
	.case_text{
		width: 100%;
		margin-top: 30px;
		img{
			max-width: 100%;
		}
	}
}
</style>
